// @owners { team: patients }
import { getImage } from '~shared/assets/images/getImage';

// Single source of truth for Progyny screen image assets. All properties are getters (not direct
// imports) so they re-resolve per brand on each access — getBrand() can return 'fuzerx' on native
// via the fuze_brand_override flag, not just 'alto'. No web-specific variant of this file is
// needed since getImage() itself handles the per-platform/per-brand asset resolution.
export const progynyAssets = {
  get calculateIcon() {
    return getImage('progynyCalculateIcon');
  },
  get calendarIcon() {
    return getImage('progynyCalendarIcon');
  },
  get logo() {
    return getImage('progynyLogo');
  },
  get medicationsIcon() {
    return getImage('progynyMedicationsIcon');
  },
};
